export const SITE = {
  name: "Sashti Jewels",
  domain: "Sashtijewels.in",
  tagline: "Timeless Elegance, Inspired by Tradition",
  // Placeholder — replace with the store's real WhatsApp business number.
  whatsappNumber: "918098832079",
  whatsappDisplay: "+91 80988 32079",
  email: "swathyravi75@gmail.com",
};

export const whatsappLink = (message) =>
  `https://wa.me/${SITE.whatsappNumber}?text=${encodeURIComponent(message)}`;

export const CATEGORIES = [
  "Necklaces",
  "Harams",
  "Chokers",
  "Chains",
];

export const REELS = [
  { id: "DWk8O95gWfY", url: "https://www.instagram.com/reel/DWk8O95gWfY/" },
  { id: "DWq7MWxjDiE", url: "https://www.instagram.com/reel/DWq7MWxjDiE/" },
  { id: "DWtFJ1ZgavK", url: "https://www.instagram.com/reel/DWtFJ1ZgavK/" },
];
